import * as types from './Types.js';

export function findOrgaos() {
  return ({ fetch }) => ({
    type: types.PROGRAMATICAORGAO,
    payload: {
      promise: fetch(
        '/api/emendas-parlamentares/contabilidade/programatica/orgaos'
      )
    }
  });
}

export function findUnidades(filtro) {
  const params = new URLSearchParams(filtro);
  const orgao = params.get('orgao');
  return ({ fetch }) => ({
    type: types.PROGRAMATICAUNIDADE,
    payload: {
      promise: fetch(
        `/api/emendas-parlamentares/contabilidade/programatica/unidades?${filtro}`,
        { headers: { orgao } }
      )
    }
  });
}

export function findFuncoes(filtro) {
  return ({ fetch }) => ({
    type: types.PROGRAMATICAFUNCAO,
    payload: {
      promise: fetch(
        `/api/emendas-parlamentares/contabilidade/programatica/funcoes?${filtro}`
      )
    }
  });
}

export function findSubfuncoes(filtro) {
  return ({ fetch }) => ({
    type: types.PROGRAMATICASUBFUNCAO,
    payload: {
      promise: fetch(
        `/api/emendas-parlamentares/contabilidade/programatica/subfuncoes?${filtro}`
      )
    }
  });
}

export function findProgramas(filtro) {
  return ({ fetch }) => ({
    type: types.PROGRAMATICAPROGRAMA,
    payload: {
      promise: fetch(
        `/api/emendas-parlamentares/contabilidade/programatica/programas?${filtro}`
      )
    }
  });
}

export function findProjetos(filtro) {
  return ({ fetch }) => ({
    type: types.PROGRAMATICAPROJETO,
    payload: {
      promise: fetch(
        `/api/emendas-parlamentares/contabilidade/programatica/projetos?${filtro}`
      )
    }
  });
}

export function findElementos(filtro) {
  return ({ fetch }) => ({
    type: types.PROGRAMATICAELEMENTO,
    payload: {
      promise: fetch(
        `/api/emendas-parlamentares/contabilidade/programatica/elementos?${filtro}`
      )
    }
  });
}

export function findDespesas(filtro) {
  const params = new URLSearchParams(filtro);
  const elemento = params.get('elemento');
  return ({ fetch }) => ({
    type: types.DESPESA,
    payload: {
      promise: fetch(
        `/api/emendas-parlamentares/contabilidade/programatica/despesas?${filtro}`,
        { headers: { elemento } }
      )
    }
  });
}

export function findFontes(filtro) {
  return ({ fetch }) => ({
    type: types.FONTE,
    payload: {
      promise: fetch(
        `/api/emendas-parlamentares/contabilidade/programatica/fontes?${filtro}`
      )
    }
  });
}
